// Login.jsx
import React, { Component } from 'react';
import axios from 'axios'

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: '8px',
            width: '40ch',
            minWidth: '25ch',
            maxWidth: '90%'
        },
    },
});

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username: this.props.match.params.username,
            password: '',
            passwordCheck: '',
            error: null,
            emailtoken : this.props.match.params.emailtoken
        };
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onSubmit = async (event) => {


        if (this.state.emailtoken){
            console.log('email token present')

            let data = {
                emailToken : this.state.emailtoken,
                password : this.state.password
            }

            axios.post('/api/user/resetPasswordByEmail', data).then((res) => {
                console.log('res', res)
                if (res.status === 200) {
                    this.props.history.push('/login');
                }
                else {
                    const error = new Error(res.error);
                    throw error;
                }
            })
            .catch(error => {
                console.log("error:" + error);
                this.setState({
                    error: error.message
                });
            });
        }
        else{
            console.log('email token  not available ')
            let token = sessionStorage.getItem('accessToken');

            let res = await axios.post('/api/user/resetPassword',  this.state, {
                headers: { Authorization: token }
            })

            if (res.status === 200) {               
                this.props.history.goBack();
            } else {
                const error = new Error(res.error);
                throw error;
            }
        }
        
    }

    onCancel = (event) => {
        this.props.history.goBack();
    }


    hideError = () => {
        this.setState({ error: '' })
    }

    componentDidMount() {
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== this.state.password) {
                return false;
            }
            return true;
        });
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isPasswordMatch');
    }

    render() {
        const { classes } = this.props;

        // const { username, emailtoken } = this.props.match.params

        return (
            <ValidatorForm
                noValidate
                onSubmit={this.onSubmit}
            >
                {this.state.error &&
                    <div>
                        <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                        <br />
                    </div>
                }

                <div className={classes.root} style={{ textAlign: 'center' }}>
                    <h3> {this.props.t('UserProfile.ResetPassword')} </h3>
                    <br />

                    {this.props.match.params.username === undefined &&
                        <TextValidator
                            id="username"
                            label= {this.props.t('UserProfile.Username')}
                            type="text"
                            className={[].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.username}
                            validators={['required']}
                            errorMessages={['username is required']}
                            name='username'
                            required
                        />
                    }

                    {this.props.match.params.username !== undefined &&
                        <TextField
                            id="password"
                            label= {this.props.t('UserProfile.Username')}
                            type="text"
                            className={[].join(' ')}
                            value={this.state.username} name='username' disabled
                        />
                    }

                    <TextValidator
                        id="password"
                        label= {this.props.t('UserProfile.Password')}
                        type="password"
                        className={[].join(' ')}
                        onChange={this.handleChange}
                        value={this.state.password}
                        validators={['required']}
                        errorMessages={['Password is required']}
                        name='password'
                        required
                    />
                    <TextValidator
                        id="passwordCheck"
                        label={this.props.t('UserProfile.ConfirmPassword')}
                        type="password"
                        className={[classes.textField].join(' ')}
                        onChange={this.handleChange}
                        value={this.state.passwordCheck}
                        validators={['isPasswordMatch', 'required']}
                        errorMessages={['Password and Confirm Password must match', 'Confirm Password is required']}
                        name='passwordCheck'
                        required
                    />
                    <br />

                    <Button variant="contained" style={{ whiteSpace: 'nowrap', width: 'fit-content' }} type="submit" color="primary" className={[].join(' ')} > {this.props.t('UserProfile.ChangePassword')} </Button>
                    <br /><br />
                    <Button variant="outlined" className={[].join(' ')} onClick={this.onCancel}> {this.props.t('UserProfile.Cancel')} </Button>
                </div>
            </ValidatorForm>
        );
    }
}

// export default Login;
export default withStyles(styles, { withTheme: true })(withTranslation()(Login));
